// Résout l'URL de base de l'API : identique à REACT_APP_BACKEND_URL, sauf si la page est servie depuis
// une autre origine (domaine personnalisé) → même origine, pour éviter CORS et cookies tiers.
export function resolveApiBase(envUrl, pageOrigin) {
  if (!pageOrigin) return envUrl;
  try {
    const envOrigin = new URL(envUrl).origin;
    if (envOrigin === pageOrigin) return envUrl;
  } catch {
    return pageOrigin;
  }
  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(pageOrigin)) return envUrl;
  return pageOrigin;
}

export const API_BASE = resolveApiBase(
  process.env.REACT_APP_BACKEND_URL,
  typeof window !== "undefined" ? window.location.origin : ""
);
